import {
  Home,
  Search,
  ShoppingCart,
  VolunteerActivism,
} from "@mui/icons-material";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MobNav = () => {
  const [value, setValue] = useState(0);

  // console.log(value);

  const navigate = useNavigate();

  return (
    <>
      <main className="responsive-nav-main w-100">
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<Home />}
            onClick={() => {
              navigate("/");
            }}
          />

          <BottomNavigationAction
            label="Search"
            icon={<Search />}
            onClick={() => {
              navigate("/search");
            }}
          />
          <BottomNavigationAction
            label="Order"
            icon={<ShoppingCart />}
            onClick={() => {
              navigate("/ordernow");
            }}
          />
          <BottomNavigationAction
            label="Donate"
            icon={<VolunteerActivism />}
            onClick={() => {
              navigate("/donate");
            }}
          />
        </BottomNavigation>
      </main>
    </>
  );
};

export default MobNav;
